/**
 * Browser-side Supabase client (re-export for backward compatibility)
 * 
 * This file re-exports the singleton browser client from lib/supabaseClient.ts
 * to maintain backward compatibility with existing imports.
 * 
 * For new code, import directly from '@/lib/supabaseClient' instead.
 * 
 * DO NOT create new clients here - use the singleton from lib/supabaseClient.ts
 */

'use client';

// Re-export the singleton browser client
export {
  supabaseClient as supabase,
  getSupabaseBrowserClient,
  getClientInstanceId
} from '@/lib/supabaseClient';

// Debug environment variables (only log once on module load)
import { logger } from '@/lib/logger';

logger.log('🔍 Environment variables check:', {
  url: process.env.NEXT_PUBLIC_SUPABASE_URL,
  key: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ? 'present' : 'missing',
  googleMaps: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ? 'present' : 'missing'
});
